import { Flex, LegacyText } from '@lemonade-hq/cdk';
import JoinCTA from '@/components/shared/JoinCTA';
import { useShowHeaderCtaOnScroll } from '@/hooks/useShowHeaderCtaOnScroll';
import trustPilotLogo from '@/static/assets/reviews/trustpilot.svg';
import Image from 'next/image';
import type React from 'react';

interface HeroCTAProps {
  ctaLabel?: string;
  ctaUrl?: string;
}

export const HeroCTA: React.FC<HeroCTAProps> = ({ ctaLabel, ctaUrl }) => {
  const { ref: mainCtaRef } = useShowHeaderCtaOnScroll();

  return (
    <Flex flexDirection="column" gap="24px" alignItems="center">
      <JoinCTA
        size="big"
        flavor="primary"
        glowing
        minWidth={233}
        analyticsParams={{ position: 'center' }}
        ref={mainCtaRef}
        customUrl={ctaUrl}
      >
        {ctaLabel}
      </JoinCTA>
      <Flex alignItems="flex-end" gap="16px">
        <LegacyText type="main" fontSize="1.8rem">
          Rated <b>4.4</b> out of 5
        </LegacyText>
        <Image src={trustPilotLogo.src} alt="Trustpilot" width={118} height={29} />
      </Flex>
    </Flex>
  );
};
